table.table {
  background-color: transparent;
}

.table :is(th, td):first-child {
  padding-left: 0;
}

.table :is(th, td):last-child {
  padding-right: 0;
}

.table .number {
  text-align: right;
  white-space: nowrap;
}

.table .total {
  font-weight: var(--font-weight-bold);
}
